var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.activeCalculator
        ? _c("b-table", {
            attrs: { items: _vm.calculatorTypeRows, fields: _vm.fields },
            scopedSlots: _vm._u(
              [
                {
                  key: "cell(calculatorType)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        "\n      " + _vm._s(data.item.calculatorName) + "\n    "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(mortgageType)",
                  fn: function (data) {
                    return [
                      _c("v-select-field", {
                        attrs: {
                          options: _vm.mortgageTypeOptionsCur,
                          "default-value": data.item.selectedMortgageType,
                          clearable: false,
                        },
                        on: {
                          "option:selected": function ($event) {
                            return _vm.handleMortgageTypeSelected(
                              data.item,
                              $event
                            )
                          },
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(action)",
                  fn: function (data) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            id: "calc-btn-wrapper-" + data.index,
                            tabindex: "0",
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "primary",
                                disabled: !_vm.isRowEligible(data.item),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.activateCalculator(data.item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("financial-tools.calculate")) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isRowEligible(data.item)
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target: "calc-btn-wrapper-" + data.index,
                                triggers: "hover focus",
                              },
                            },
                            _vm._l(
                              _vm.getEligibilityReasons(data.item),
                              function (reason, ri) {
                                return _c("div", { key: ri }, [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(reason) +
                                      "\n        "
                                  ),
                                ])
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              851617828
            ),
          })
        : _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c(_vm.activeCalculator.component, {
                key: _vm.activeCalculator.calculatorName,
                tag: "component",
                attrs: { "init-data": _vm.initData },
                on: {
                  back: function ($event) {
                    _vm.activeCalculator = null
                  },
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }